import { CitySelector, RatingFilter, Sorting } from '@/features/search'
import type { SortOption } from '@shared/types'

interface ProfessionalsSortingFilterProps {
  cityId: string
  minRating: string
  sortBy: SortOption
  onCityChange: (value: string) => void
  onRatingChange: (value: string) => void
  onSortChange: (value: SortOption) => void
  resultCount?: {
    from: number
    to: number
    total: number
  }
  isLoading?: boolean
  citiesError?: boolean
}

export function ProfessionalsSortingFilter({
  cityId,
  minRating,
  sortBy,
  onCityChange,
  onRatingChange,
  onSortChange,
  resultCount,
  isLoading,
  citiesError
}: ProfessionalsSortingFilterProps) {

  return (
    <div className="flex flex-col gap-2 mb-2" data-tour="professionals-filters">
      <CitySelector
        value={cityId}
        onChange={onCityChange}
        placeholder="Ciudad"
        disabled={!!(citiesError || isLoading)}
      />

      <div className="grid grid-cols-2 gap-2" >
        <RatingFilter
          minRating={minRating}
          onChange={onRatingChange}
          placeholder="Calificación"
          className="w-full"
          disabled={!!(citiesError || isLoading)}
        />

        <Sorting
          sortBy={sortBy}
          onChange={(v) => onSortChange(v as SortOption)}
          className="w-full"
          disabled={!!(citiesError || isLoading)}
        />
      </div>

      {resultCount && (
        <p className="text-sm text-muted-foreground text-right">
          Mostrando {resultCount.from}-{resultCount.to} de {resultCount.total}
        </p>
      )}
    </div>
  )
}
